import React, { Component } from "react";
import OutfitListView from "presentational/common/outfitUnit/OutfitListView";
import PropTypes from "prop-types";

class LoungeListPanel extends Component {
  static propTypes = {
    list: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired
  };

  render() {
    const { list, isLoading } = this.props;

    return (
      <div>
        <OutfitListView
          list={list}
          isLoading={isLoading}
          isEnd={!!list && list.length > 0}
          callNextListFn={() => {}}
          shortBottomPadding
          displayTooltipForGuest
        />
      </div>
    );
  }
}

export default LoungeListPanel;
